import { render, staticRenderFns } from "./transaction-cost.vue?vue&type=template&id=15beae39&"
import script from "./transaction-cost.vue?vue&type=script&lang=js&"
export * from "./transaction-cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports